import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

const dummyAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'clientAPI',
    endpoints: (builder) => ({

        // GET METHOD API
        dummyGetEndpoint: builder.query({
            query: (details) => ({
                url: `/ControllerName/APIEndpoint?parameterName=${details}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // POST METHOD API
        dummyPostEndpoint: builder.mutation({
            query: (details) => ({
                url: `/ControllerName/APIEndpoint`,
                method: 'GET',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const { useLazyDummyGetEndpointQuery, useDummyPostEndpointMutation } = dummyAPI;
export default dummyAPI;